import Fuse from 'fuse.js'
import { stripHtml } from "./scripts/utility/strings.js"

var AccordionSearch = class extends HTMLElement {

    selectors = {
        section: ".shopify-section--accordion-content",
        section_title: ".section-stack__intro",
        item: "details",
        item_content: ".accordion__content",
        search_form: "form.accordion-search__form",
        search_input: 'input[name="search"]',
        auto_complete: "#results",
      }

    connectedCallback() {

        this.items = document.querySelectorAll(this.selectors.section + " " + this.selectors.item);
        this.sections = document.querySelectorAll(this.selectors.section);
        this.autoComplete = this.querySelector(this.selectors.auto_complete);
        this.selectedAutoComplete = 0;

        this.index = [];
        for (var i = 0; i < this.items.length; i++) {
            const item = this.items.item(i)
            const content = item.querySelector(this.selectors.item_content);

            if(location.hash.indexOf(item.id) > -1){
                item.open = true;
            }

            this.index.push({
              id: item.id,
              title: item.innerText,
              content: content ? stripHtml(content.innerHTML) : ""
            });
        }

        const options = {
            includeScore: true,
            keys: [
              'content',
              {
                name: 'title',
                weight: 2
              }
            ]
        }

        this.fuse = new Fuse(this.index, options);

        this._buildQuickLinks();
        this._buildSchema();
        this._bindSearch();
    }

    _search = (searchValue) => {
        if(searchValue){
            const results = this.fuse.search(searchValue);
            //this.filterDom(results);
            this._trackSearch(searchValue);
            this._updateAutoComplete(results)
        }else{
            //this.unfilterDom();
        }
    }

    _buildQuickLinks = () => {
        this.linksElement = document.createElement('div');
        this.linksElement.className = "accordion-links";
        this.sections.forEach((section) => {
            var title = section.querySelector(this.selectors.section_title).innerText;
            var link = document.createElement('div');
            link.className = "accordion-links__item";
            link.innerHTML = `<a class="link" href='#${section.id}'>${title}</a>`;
            this.linksElement.appendChild(link);
        });
        this.appendChild(this.linksElement);
    }

    _buildSchema = () => {
        const questions = this.index.map(({title, content})=>{
          return {
            "@type": "Question",
            "name": title,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": content
            }
          }
        });

        const schemaData = {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": questions
        }

        var script = document.createElement('script');
        script.type = "application/ld+json";
        script.innerHTML = JSON.stringify(schemaData);
        document.head.appendChild(script);
    }

    _bindSearch = () => {
        const form = document.querySelector(this.selectors.search_form);
        const input = document.querySelector(this.selectors.search_input);

        form.addEventListener("submit", (e)=>{
          e.preventDefault();
          this.autoComplete.querySelector(".selected a")?.click();
        });

        input.addEventListener("keyup", (e)=>{
          switch(e.key){
            case "ArrowUp":
                this._selectAutoComplete(this.selectedAutoComplete - 1);
                break;
            case "ArrowDown":
                this._selectAutoComplete(this.selectedAutoComplete + 1);
                break;
            case "Enter":
                e.preventDefault();
                this.autoComplete.querySelector(".selected a")?.click();
                break;
            default:
              this._search(input.value);
          }
        });

        // const button = document.querySelector(this.selectors.button);
        // button.addEventListener("click", (e)=>{
        //   e.preventDefault();
        //   e.stopPropagation();
        //   this.goToSelection();
        // })
    }

    _selectAutoComplete = (index) => {
        const autoCompleteItems = this.autoComplete.querySelectorAll("[role='option']");

        if(autoCompleteItems.length > index){
          this.selectedAutoComplete = index
        }else if(index < 0){
          this.selectedAutoComplete = 0
        }else{
          this.selectedAutoComplete = autoCompleteItems.length - 1
        }

        for(var i = 0; i < autoCompleteItems.length; i++){
          const item = autoCompleteItems.item(i);
          if(i == this.selectedAutoComplete){
            item.classList.add("selected");
            item.setAttribute("aria-selected", true);
          }else{
            item.classList.remove("selected");
            item.setAttribute("aria-selected", false);
          }
        }

    }

    _updateAutoComplete = (results) => {
        if(results.length){
          const autoCompleteItems = results.slice(0,7).map(this._renderAutoCompleteItem);
          this.autoComplete.innerHTML = "";
          this.autoComplete.append(...autoCompleteItems);
          this.autoComplete.style.display = "block";
          this._selectAutoComplete(this.selectedAutoComplete);
        }else{
          this._clearAutoComplete();
        }
    }

    _clearAutoComplete = () => {
        this.autoComplete.innerHTML = "";
        this.autoComplete.style.display = "none";
    }

    _renderAutoCompleteItem = (result, index) => {
        const itemEl = document.createElement('li');
        itemEl.classList.add("form-control__autocomplete__item");
        itemEl.setAttribute("role", "option");
        itemEl.setAttribute("aria-selected", index === 0 ? true : false);
        const itemLink = document.createElement('a');
        itemLink.href = `#${result.item.id}`;
        itemLink.innerHTML = result.item.title;
        itemLink.addEventListener("click", (e)=>{
            var item = document.querySelector(`#${result.item.id}`)
            item.highlight = true;
        });
        itemEl.appendChild(itemLink);
        return itemEl;
    }

    _trackSearch = (searchValue) => {
        //wait 1 second before tracking, cancel if another search is made
        if(this.searchTimeout){
          clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(()=>{
          //track search
          if(window.heap){
            window.heap.track("Accordion Search", {
              search: searchValue
            });
          }
          this.searchTimeout = null;
        }, 3000);
    }

}

if (!window.customElements.get("accordion-search")) {
    window.customElements.define("accordion-search", AccordionSearch);
}